import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d54b56fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "name", "disabled"]
const _hoisted_2 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _mergeProps({
      class: ["checkbox", { 'checkbox--error': _ctx.hasError, 'disabled': _ctx.disabled, 'checkbox--valid': _ctx.valid }]
    }, _ctx.$attrs), [
      _withDirectives(_createElementVNode("input", {
        tabindex: "0",
        type: "checkbox",
        id: _ctx.id,
        name: _ctx.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
        disabled: _ctx.disabled
      }, null, 8, _hoisted_1), [
        [_vModelCheckbox, _ctx.inputValue]
      ]),
      _createElementVNode("label", { for: _ctx.id }, _toDisplayString(_ctx.label), 9, _hoisted_2)
    ], 16),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "input-field__error",
        key: index
      }, _toDisplayString(error.$message), 1))
    }), 128))
  ], 64))
}